import { OnInit } from '@angular/core';
var InfiniteProgressComponent = /** @class */ (function () {
    function InfiniteProgressComponent() {
    }
    InfiniteProgressComponent.prototype.ngOnInit = function () { };
    return InfiniteProgressComponent;
}());
export { InfiniteProgressComponent };
